var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hyrox-type-selector-component"},_vm._l((_vm.fitnessTypes),function(fType){return _c('button',{key:fType.id,class:fType.name,domProps:{"innerHTML":_vm._s(fType.name)},on:{"click":function($event){return _vm.applyFitnessType(fType.id)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }